import React from "react";
import PropTypes from "prop-types";
import { IconButton, Tooltip } from "@mui/material";
import LightModeOutlinedIcon from "@mui/icons-material/LightModeOutlined";
import DarkModeOutlinedIcon from "@mui/icons-material/DarkModeOutlined";
import SettingsBrightnessOutlinedIcon from "@mui/icons-material/SettingsBrightnessOutlined";
import { useThemeMode } from "../theme/colorThemeContext";

const ThemeModeToggle = ({ onToggle }) => {
  const { mode, modePreference, isSystemMode, toggleColorMode } = useThemeMode();

  const handleToggle = () => {
    if (onToggle) {
      onToggle();
      return;
    }

    toggleColorMode();
  };

  const icon = isSystemMode
    ? <SettingsBrightnessOutlinedIcon fontSize="small" />
    : mode === "dark"
      ? <DarkModeOutlinedIcon fontSize="small" />
      : <LightModeOutlinedIcon fontSize="small" />;

  const title = isSystemMode
    ? `Theme: System (${mode})`
    : `Theme: ${modePreference}`;

  return (
    <Tooltip title={title} arrow>
      <IconButton
        aria-label="Toggle color mode"
        onClick={handleToggle}
        color="inherit"
        sx={{
          border: "1px solid",
          borderColor: "divider",
          bgcolor: "action.hover",
          color: "text.primary",
          "&:hover": {
            bgcolor: "action.selected",
          },
        }}
      >
        {icon}
      </IconButton>
    </Tooltip>
  );
};

ThemeModeToggle.propTypes = {
  onToggle: PropTypes.func,
};

export default ThemeModeToggle;
